<template>
  <header class="header-wrap">
    <w-top-nav />
    <w-header-container />
    <w-header-category />
  </header>
</template>

<script>
import WTopNav from '@/views/layout/components/WTopNav'
import WHeaderContainer from '@/views/layout/components/WHeaderContainer'
import WHeaderCategory from '@/views/layout/components/WHeaderCategory'
export default {
  components: {
    WTopNav,
    WHeaderContainer,
    WHeaderCategory
  }
}
</script>

<style lang="scss" scoped>

</style>